<template>
  <form @submit.prevent="saveInstrument" class="w-full">
    <div class="flex flex-col w-full" v-if="newInstrument">
        <span class="border-b-2 w-full p-2 uppercase border-grey-academy-150
        bg-beige-academy-200" v-if="!addNewUnknownInstrument">
          {{ newInstrument.name }}
        </span>
        <div v-else class="flex flex-col">
          <div class="flex justify-between items-center mt-3">
            <label for="school" class="w-1/3">{{$t('skills.instr-name')}}:</label>
            <input type="text" id="school" v-model="newInstrument.name" required
            class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200">
            <span class="text-red-500"
              v-if="errors.has('name')"
              v-text="errors.get('name')"
            >
            </span>
          </div>
        </div>
        <div class="flex justify-between items-center mt-5">
          <label for="course" class="w-1/3">
            {{ isTeacher ? $t('skills.teaching-years') : $t('skills.practise-years')}}:
          </label>
          <input type="text" id="course" v-model="newInstrumentData.years" required
            class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200">
          <span class="text-red-500"
            v-if="errors.has('years')"
            v-text="errors.get('years')"
          >
          </span>
        </div>
        <div class="flex flex-col justify-between items-center mt-5">
          <label for="qualification" class="w-full mb-2" v-if="isTeacher">
            {{$t('skills.teach-method')}} <br>
            {{$t('skills.students')}} <br>
          </label>
          <label for="qualification" class="w-full mb-2" v-else>
            {{$t('skills.instrument')}} <br>
            {{$t('skills.why')}} <br>
            {{$t('skills.for')}}
          </label>
          <textarea type="text" id="qualification" v-model="newInstrumentData.description" required
            class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200" />
          <span class="text-red-500"
            v-if="errors.has('description')"
            v-text="errors.get('description')"
          >
          </span>
        </div>
      </div>
      <div class="flex" v-if="value && !newInstrument">
        <auto-suggest-instrument @selected="instrumentSelected($event)"
          v-model="instrumentDigit" @empty="emptyAlgoliaInstruments = true" />
      </div>
      <div class="w-full">
        <button class="w-auto bg-orange-academy-300 text-white p-2 rounded border
        hover:bg-white hover:text-orange-academy-300 border-orange-academy-300"
        @click.prevent="$emit('input', true)" v-if="!newInstrument && !emptyAlgoliaInstruments">
          {{$t('skills.add-instrument')}}
        </button>
        <div v-if="newInstrument" class="flex items-center">
          <button class="w-auto bg-orange-academy-300 text-white p-2 rounded border mr-6
          hover:bg-white hover:text-orange-academy-300 border-orange-academy-300 mt-6"
          @click.prevent="reset" >
            {{$t('bookingSlots.cancel')}}
          </button>
          <button class="w-auto bg-orange-academy-300 text-white p-2 rounded border
          hover:bg-white hover:text-orange-academy-300 border-orange-academy-300 mt-6">
            {{$t('editingSlots.save')}}
          </button>
        </div>
        <div v-if="emptyAlgoliaInstruments && !newInstrument && value"
        class="flex w-full justify-end items-center">
          {{$t('skills.new-instrument')}}
          <button class="w-auto bg-orange-academy-300 text-white p-2 rounded border
            hover:bg-white hover:text-orange-academy-300 border-orange-academy-300 ml-4"
            @click.prevent="addNewInstrument" >
             {{$t('skills.add-instrument')}}
          </button>
        </div>
      </div>
  </form>
</template>

<script>
import Errors from '@/util/Errors';
import AutoSuggestInstrument from '@/components/AutoSuggestInstrument.vue';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: ['value', 'instruments'],

  components: {
    AutoSuggestInstrument,
  },

  data() {
    return {
      addNewUnknownInstrument: false,
      newInstrument: null,
      newInstrumentData: {
        years: '',
        description: '',
      },
      instrumentDigit: '',
      emptyAlgoliaInstruments: false,
      errors: new Errors(),
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
    }),
  },

  mixins: [StreamFunctionsMixin],

  methods: {
    instrumentSelected(instrument) {
      this.newInstrument = instrument.item;
    },

    addNewInstrument() {
      this.addNewUnknownInstrument = true;
      this.newInstrument = {
        name: this.instrumentDigit,
        slug: '',
      };
    },

    saveInstrument() {
      if (!this.newInstrument.id) {
        this.newInstrument.name = this.capitalLetter(this.newInstrument.name.toLowerCase());
        this.newInstrument.slug = this.newInstrument.name.toLowerCase();
        axios.post('/api/instruments', this.newInstrument).then(({ data }) => {
          this.newInstrument = data;
          this.addTeacherInstrument();
        }).catch(({ response: { data: { errors } } }) => {
          this.errors.record(errors);
        });
        return;
      }
      this.addTeacherInstrument();
    },

    addTeacherInstrument() {
      if (this.instruments.some((instrument) => instrument.slug === this.newInstrument.slug)) {
        this.createNotification('warning', this.$t('skills.instrumentAlreadyExist'));
        return;
      }

      const userId = this.isTeacher
        ? this.user.teacher.id
        : this.user.student.id;
      axios.post(`/api/${this.isTeacher ? 'teachers' : 'students'}/${userId}/instruments/${this.newInstrument.id}`,
        this.newInstrumentData).then(() => {
        this.$emit('instrument-added');
        this.reset();
      }).catch(({ response: { data: { errors } } }) => {
        this.errors.record(errors);
      });
    },

    reset() {
      this.$emit('input', false);
      this.newInstrument = null;
      this.addNewUnknownInstrument = false;
      this.newInstrumentData = {
        years: '',
        description: '',
      };

      this.emptyAlgoliaInstruments = false;
    },

  },
};
</script>
